import { createAction, props } from '@ngrx/store';

import { AuditLog, Pagination } from '../../../shared/models';
import {
  ShelfReplenishmentPhotoListContent,
  ShelfReplenishmentPhotoSearchCriteria,
  ShelfReplenishmentPhotoTaskSummaryResponse,
  ShelfReplenishmentPhotoView
} from '../model/shelf-replenishment-photo.model';

export const shelfReplenishmentPhotoAction = {
  shelfReplenishmentPhotoListRequest: createAction(
    '[Shelf Replenishment Photo Action] Shelf Replenishment Photo Action List Request',
    props<{ criteriaObject: ShelfReplenishmentPhotoSearchCriteria }>()
  ),
  shelfReplenishmentPhotoListResponse: createAction(
    '[Shelf Replenishment Photo Action] Shelf Replenishment Photo Action List Response',
    props<{
      data: Pagination<ShelfReplenishmentPhotoListContent>;
    }>()
  ),
  shelfReplenishmentPhotoViewRequest: createAction(
    '[Shelf Replenishment Photo Action] Shelf Replenishment Photo Action View Request',
    props<{ jobNo: string }>()
  ),
  shelfReplenishmentPhotoTaskSummaryRequest: createAction(
    '[Shelf Replenishment Photo Action] Shelf Replenishment Photo Summary Request'
  ),
  shelfReplenishmentPhotoTaskSummaryResponse: createAction(
    '[Shelf Replenishment Photo Action] Shelf Replenishment Photo Summary Response',
    props<{ response: ShelfReplenishmentPhotoTaskSummaryResponse }>()
  ),
  shelfReplenishmentPhotoViewResponse: createAction(
    '[Shelf Replenishment Photo Action] Shelf Replenishment Photo Action View response',
    props<{ response: ShelfReplenishmentPhotoView }>()
  ),
  shelfReplenishmentPhotoActionSubmitRequest: createAction(
    '[Shelf Replenishment Photo Action] Shelf Replenishment Photo Action Submit Request',
    props<{ payload: { jobNo: string; version: number; items: any[] } }>()
  ),
  shelfReplenishmentPhotoActionReset: createAction(
    '[Shelf Replenishment Photo Action] Shelf Replenishment Photo Action Reset'
  ),
  shelfReplenishmentPhotoListActionReset: createAction(
    '[Shelf Replenishment Photo Action] Shelf Replenishment Photo List Action Reset'
  ),
  shelfReplenishmentPhotoActionHistoryRequest: createAction(
    '[Shelf Replenishment Photo Action] Shelf Replenishment Photo Action History Request',
    props<{ payload: { jobNo: string } }>()
  ),
  shelfReplenishmentPhotoActionHistoryResponse: createAction(
    '[Shelf Replenishment Photo Action] Shelf Replenishment Photo Action History Response',
    props<{ response: AuditLog[] }>()
  )
};
